module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "400px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Assign Campaign to the Post\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "body-2"
  }, [(_vm.postData !== null) ? _c('p', [_vm._v("\n        Inputted name from Creator: "), _c('span', {
    staticClass: "font-italic"
  }, [_vm._v(_vm._s(_vm.postData.campaignName))])]) : _vm._e(), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "items": _vm.campaignList,
      "label": "Choose Campaigns in IMS:",
      "item-value": "id",
      "item-text": "name"
    },
    model: {
      value: (_vm.selectedCampaignID),
      callback: function($$v) {
        _vm.selectedCampaignID = $$v
      },
      expression: "selectedCampaignID"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.assignCampaign()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42c907fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Post/AssignCampaignModal.vue
// module id = 2096
// module chunks = 0